import { MixedSchema } from '@principle-theorem/editor';
import {
  ReferralContextBuilder,
  ScopeDataBuilder,
  compileTemplate,
  compileTemplateSchema,
} from '@principle-theorem/principle-core';
import {
  IPractice,
  IReferral,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef } from '@principle-theorem/shared';

export interface IPatientLetterDefaults {
  resolvedEmailBody: MixedSchema | undefined;
  resolvedSubject: string | undefined;
}

export async function resolvePatientLetterDefaults(
  referral: WithRef<IReferral>,
  practice: WithRef<IPractice>,
  appUrl: string
): Promise<IPatientLetterDefaults> {
  const templateSlot =
    practice.settings?.referral?.emailTemplateDefaults?.patientLetter;

  if (!templateSlot?.templateRef && !templateSlot?.subject) {
    return { resolvedEmailBody: undefined, resolvedSubject: undefined };
  }

  const scopeData = await ScopeDataBuilder.buildReferralScopeData(
    referral,
    practice,
    appUrl
  );
  const context = new ReferralContextBuilder(scopeData).build();

  let resolvedEmailBody: MixedSchema | undefined;
  let resolvedSubject: string | undefined;

  if (templateSlot.templateRef) {
    const templateDoc = await Firestore.safeGetDoc(templateSlot.templateRef);
    if (templateDoc && !templateDoc.deleted) {
      resolvedEmailBody = compileTemplateSchema(templateDoc.content, context);
    }
  }

  if (templateSlot.subject) {
    resolvedSubject = compileTemplate(templateSlot.subject, context);
  }

  return { resolvedEmailBody, resolvedSubject };
}
